<div class="container animated fadeInRight" *ngIf="!mostrarFormulario">
  <app-lfsa-card [innTemplate]="puntoEntrega" [titulo]="'CREAR EMPLEADO'" [efecto]="true" [colapseName]="'puntoEntrega'"
    [banderaColapse]='true'></app-lfsa-card>

  <ng-template #puntoEntrega>
    <div [formGroup]="formulario" novalidate class="form-group">
    <div class="row">

      <div class="form-group col-md-1">
          <label>Cédula Nac. o Ext. </label><br>
          <input id="cedulaNacional" formControlName="cedulaNacional" type="checkbox" />&nbsp;
          <span>Es nacional</span>
      </div> 

      <div class="form-group col-md-3">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('cedula')"
          [placeholder]="'Cédula'" formControlName="cedula" [label]="'Cédula*'" [type]="'number'"
          [id]="'cedula'"   (keydown.enter)="validateUser()" (keydown.tab)="validateUser()" >
        </app-lfsa-input>
     </div>
     <div class="form-group col-md-4">
        <app-lfsa-input  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('email')"
          [placeholder]="'Correo'" formControlName="email" [label]="'Correo'" [type]="'email'"
          [id]="'email'">
        </app-lfsa-input>
      </div>
      <div class="form-group col-md-2">
        <app-lfsa-input  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('fechaIngreso')" [claseLabel]="'letrasDanger'"
          [placeholder]="'Fecha de ingreso'" formControlName="fechaIngreso" [label]="'Fecha de Ingreso*'" [type]="'date'"
          [id]="'fechaIngreso'">
        </app-lfsa-input>
     </div>
      <div class="form-group col-md-2">
        <app-lfsa-input  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('fechaSalida')" [claseLabel]="'letrasDanger'"
          [placeholder]="'Fecha de salida'" formControlName="fechaSalida" [label]="'Fecha de Salida*'" [type]="'date'"
          [id]="'fechaSalida'">
        </app-lfsa-input>
     </div>
    </div>
    
    <div class="row">
      <div class="form-group col-md-4">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('nombres')"
          [placeholder]="'Nombres'" formControlName="nombres" [label]="'Nombres*'" [type]="'text'"
          [id]="'nombres'" (keydown.Tab)="keyPress($event)" (mouseout)="keyPress($event)">
        </app-lfsa-input>
        <!-- {{ formulario.get('nombres').value | json }} -->
      </div>
      <div class="form-group col-md-3">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('IESS')"
          [placeholder]="'IESS'" formControlName="IESS" [label]="'IESS*'" [type]="'text'" [isReadOnly]="true"
          [id]="'IESS'">
        </app-lfsa-input>
      </div>
      <div class="form-group col-md-1">
          <label>Doc.IESS</label><br>
          <input id="documentoIess" type="checkbox" (click)="setCheckForm(formulario.get('documentoIess').value)"/>&nbsp;
          <span>{{ statusCheck }}</span>
      </div> 
        <div class="form-group col-md-2">
          <app-lfsa-input  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('fechaPrimero')" 
            [placeholder]="'Fecha de primer contrato'" formControlName="fechaPrimero" [label]="'Primer contrato'" [type]="'date'"
            [id]="'fechaPrimero'">
          </app-lfsa-input>
       </div>
       <div class="form-group col-md-2">
        <app-lfsa-input  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('fechaUltimo')" 
          [placeholder]="'Fecha de último contrato'" formControlName="fechaUltimo" [label]="'Último contrato'" [type]="'date'"
          [id]="'fechaUltimo'">
        </app-lfsa-input>
        </div>
    </div>
    <br>
    <!--FIRST------------------------------------------------------FIRST --->
    <div class="row">
      <div class="form-group col-md-6">
        <app-lfsa-input  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('fechaNacimiento')" [claseLabel]="'letrasDanger'"
          [placeholder]="'Fecha de nacimiento'" formControlName="fechaNacimiento" [label]="'Fecha de nacimiento*'" [type]="'date'"
          [id]="'fechaNacimiento'">
        </app-lfsa-input>
     </div>

     <div class="form-group col-md-6">
        <app-lfsa-combo-box (change)='seleccionLocalidad()' [claseLabel]="'letrasDanger'"
              [opcion]="'descripcion'" [idOpcion]="'descripcion'" [comboBox]="cmbLocalidad" formControlName="localidad"
              [control]="formulario.get('localidad')" [label]="'Localidad*'" [id]="'localidad'" >
        </app-lfsa-combo-box>
      </div>
    </div>
    <br>
    <!--SECOND------------------------------------------------------SECOND --->
    <div class="row">
      <div class="form-group col-md-3">
        <app-lfsa-combo-box (change)='seleccionEmpresa()' [claseLabel]="'letrasDanger'"
                [opcion]="'descripcion'" [idOpcion]="'descripcion'" [comboBox]="cmbEmpresa" formControlName="empresa"
                [control]="formulario.get('empresa')" [label]="'Empresa*'" [id]="'empresa'">
            </app-lfsa-combo-box>
     </div>
     <div class="form-group col-md-3">
        <app-lfsa-combo-box  (change)='selecionCargo()' [claseLabel]="'letrasDanger'"
                [opcion]="'descripcion'" [idOpcion]="'descripcion'" [comboBox]="cmbCargos" formControlName="cargo"
                [control]="formulario.get('cargo')" [label]="'Cargo*'" [id]="'cargo'">
            </app-lfsa-combo-box>
      </div>
      <div class="form-group col-md-3" (dblclick)="clearCmb('areaTrabajo')">
        <app-lfsa-combo-box (change)='selectionDepartamento()'  
              [opcion]="'descripcion'" [idOpcion]="'descripcion'" [comboBox]="cmbDepartamento" formControlName="areaTrabajo"
              [control]="formulario.get('areaTrabajo')" [label]="'Departamento'" [id]="'areaTrabajo'">
        </app-lfsa-combo-box>
     </div>
     <div class="form-group col-md-3">
      <app-lfsa-input   
          [control]="formulario.get('telefono')" 
          [placeholder]="'Ingresar Celular  MAX(10)'" formControlName="telefono"
          [label]="'Celular'" [type]="'number'" [id]="'telefono'"
          (keyup)="onValidacionCelular($event.target)">
      </app-lfsa-input>
      <small class="letrasDanger" *ngIf="errorTelefono">El Celular debe iniciar por 0. ejem:
          0978824516</small>
    </div>
     
     <!--<div class="form-group col-md-3">
        <app-combo-box (change)='selecionEstadoCivil()' 
                [opcion]="'descripcion'" [idOpcion]="'id'" [comboBox]="cmbEstadoCivil" formControlName="estadoCivil"
                [control]="formulario.get('estadoCivil')" [label]="'Estado Civil'" [id]="'estadoCivil'">
            </app-combo-box>
      </div>-->
    </div>
    <br>
    <!--THIRD------------------------------------------------------THIRD --->
    <div class="row">
      <div class="form-group col-md-3">
        <app-lfsa-input [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('pais')" [claseLabel]="'letrasDanger'"
          [placeholder]="'País'" formControlName="pais" [label]="'País*'" [type]="'text'"
          [id]="'pais'">
        </app-lfsa-input>
     </div>
     <div class="form-group col-md-3"  (dblclick)="clearCmb('provincia')">
        <app-lfsa-combo-box  (change)='selecionProvincias()' 
        [opcion]="'nombre'" [idOpcion]="'nombre'" [comboBox]="cmbProvincias" formControlName="provincia"
        [control]="formulario.get('provincia')" [label]="'Provincia'" [id]="'provincia'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-md-3" (dblclick)="clearCmb('canton')">
        <app-lfsa-combo-box (change)='selecionCanton()' 
        [opcion]="'nombre'" [idOpcion]="'nombre'" [comboBox]="cmbCantones" formControlName="canton"
        [control]="formulario.get('canton')" [label]="'Canton'" [id]="'canton'">
        </app-lfsa-combo-box>
     </div>
     <div class="form-group col-md-3">
        <app-lfsa-input  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('direccion')" 
          [placeholder]="'Dirección'" formControlName="direccion" [label]="'Direccción'" [type]="'text'"
          [id]="'direccion'">
        </app-lfsa-input>
      </div>
    </div>
    <br>
    <!--FOURTH------------------------------------------------------FOURTH --->
    <div class="row">
      <div class="form-group col-md-3" (dblclick)="clearCmb('genero')">
        <app-lfsa-combo-box (change)='selecionGenero()'  
                [opcion]="'descripcion'" [idOpcion]="'descripcion'" [comboBox]="cmbOrientacion" formControlName="genero"
                [control]="formulario.get('genero')" [label]="'Genero'" [id]="'genero'">
            </app-lfsa-combo-box>
     </div>
     <div class="form-group col-md-3" (dblclick)="clearCmb('regionDomi')">
      <app-lfsa-combo-box (change)='selecionRegion()' 
              [opcion]="'descripcion'" [idOpcion]="'descripcion'" [comboBox]="cmbRegion" formControlName="regionDomi" 
              [control]="formulario.get('regionDomi')" [label]="'Region Domiciliaria'" [id]="'regionDomi'">
          </app-lfsa-combo-box>
      </div>
      <div class="form-group col-md-3" (dblclick)="clearCmb('codCosto')">
        <app-lfsa-combo-box (change)='selecionCodigoCosto()'
              [opcion]="'descripcion'" [idOpcion]="'descripcion'" [comboBox]="cmbCodigoCosto" formControlName="codCosto"
              [control]="formulario.get('codCosto')" [label]="'Codigo de Costos'" [id]="'codCosto'">
        </app-lfsa-combo-box>
     </div>
     <div class="form-group col-md-3">
        <app-lfsa-input  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('reportaA')"
          [placeholder]="'Escriba cedula'" formControlName="reportaA" [label]="'Reporta a:'" [type]="'text'"
          [id]="'reportaA'">
        </app-lfsa-input>
      </div>
    </div>
    <br>
    <!--QUINTA LINEA------------------------------------------------------QUINTA --->
    <div class="row">
      <div class="form-group col-md-3">
        <app-lfsa-combo-box (change)='seleccionEmpresa()' [claseLabel]="'letrasDanger'"
                [opcion]="'descripcion'" [idOpcion]="'id'" [comboBox]="cmbTipoEmpleado" formControlName="tipoEmpleado"
                [control]="formulario.get('tipoEmpleado')" [label]="'Tipo Empleado*'" [id]="'tipoEmpleado'">
            </app-lfsa-combo-box>
     </div>
     <div class="form-group col-md-3">
        <app-lfsa-combo-box  (change)='selecionEmpresaSolicita()' (change)="changeClearSolicitados($event)" [claseLabel]="'letrasDanger'"
                [opcion]="'descripcion'" [idOpcion]="'descripcion'" [comboBox]="cmbEmpresaSolicita" formControlName="empresaSolicita"
                [control]="formulario.get('empresaSolicita')" [label]="'Empresa Solicitante*'" [id]="'empresaSolicita'">
            </app-lfsa-combo-box>
      </div>
      <div class="form-group col-md-3" (dblclick)="clearCmb('departamentoSolicita')">
        <app-lfsa-combo-box (change)='selecionDepartamentoSolicita()'
              [opcion]="'descripcion'" [claseLabel]="claseLabel" [idOpcion]="'descripcion'" [comboBox]="cmbDepartamentoSolicita" formControlName="departamentoSolicita"
              [control]="formulario.get('departamentoSolicita')" [label]="depSolicita" [id]="'departamentoSolicita'">
        </app-lfsa-combo-box>
     </div>
     <div class="form-group col-md-3" (dblclick)="clearCmb('empleadoSolicita')" >
      <app-lfsa-combo-box (change)='selecionEmpleadoSolicita()'  
            [opcion]="'nombres'" [claseLabel]="claseLabel" [idOpcion]="'cedula'" [comboBox]="cmbEmpleadoSolicita" formControlName="empleadoSolicita"
            [control]="formulario.get('empleadoSolicita')" [label]="empSolicitante" [id]="'empleadoSolicita'">
      </app-lfsa-combo-box>
    </div>
     
    </div>
    
    <div class="row">
      <div class="col-md-12">
          <label for="">Motivo de visita</label>
          <textarea placeholder="Descripción o Motivo de la visita MAX 250 Caracteres (Obligatorio)"
              class="form-control rounded-0"
              [ngClass]="{'is-invalid': formulario.get('motivoVisita').invalid && formulario.get('motivoVisita').dirty, 'is-valid': formulario.get('motivoVisita').valid}"
              rows="2" formControlName="motivoVisita"
              oninput="this.value = this.value.toUpperCase()"
              >
            </textarea>
            <!--(input)="this.formulario.patchValue({motivoVisita: $event.target.value.toUpperCase()})"-->
          <app-lfsa-error-msg [control]="this.formulario.get('motivoVisita')" [label]="">
          </app-lfsa-error-msg>
      </div>
  </div>
<!-- {{ formulario.value | json}} -->
    <br>

    <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
    <div class="row">
      <div class="form-group col-12">
        <div *ngIf="formulario.invalid" class="alert alert-danger animated fadeInRight" role="alert">
          <b> Complete la información solicitada, luego se habilitara el botón...!!! </b>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="!loading">
      <div class="form-group col-12">    
          <button class="btn btn-success btn-block" [disabled]="formulario.invalid"
          (click)="enviarFormulario()">Enviar</button>
      </div>
    </div>

    



  </div>
    
  </ng-template>
  <div class="row">
    <div class="col-md-12">
      <button [routerLink]="['/emp/administrador/home-emp']"
        class="btn btn-outline-danger btn-block btn-lg">Regresar</button>
    </div>
  </div>
  <br>
  
</div>


<div class="modal fade showProducto" tabindex="-1" role="dialog" aria-labelledby="myExtraLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable">    <!--modal-dialog modal-xl -->
   <div class="modal-content">
       <div class="modal-header">
           <h5 class="modal-title" id="exampleModalLabel">Selecione Empleado</h5>
           <button type="button" #closebutton class="close" data-dismiss="modal" aria-label="Close">
                   <span aria-hidden="true">&times;</span>
           </button>
       </div>
       <div class="modal-body">
           <div class="form-group" >
               <h4 class="container float-left">Buscar </h4>
              
               <div class="container">
                   <div class="row">
                       <div class="col ">
                           <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscar" id="quickFilter " (keyup)="onQuickFilterChanged() " #quickFilter/>
                       </div>
                       <div class="col ">
                           <!-- <button (click)="nuevaLinea()" [ngClass]="{'float-right': true, 'mx-3': true}" class={{tvcModulo.button.buttonsCss.success}}>{{tvcModulo.button.buttonsNombre.agregar}}</button> -->
                       </div>
                   </div>
               </div>
               <ag-grid-angular #agGrid style="width: 100%; height: 450px; " class="ag-theme-material mt-3" [frameworkComponents]="frameworkComponents " 
                   [columnDefs]="columnDefs" 
                   [rowSelection]="rowSelection" 
                   [rowData]="rowData" 
                   (gridReady)="onGridReady($event)"
                   [pagination]="true">
               </ag-grid-angular> 
           </div>

       </div>
       
   </div>
 </div>
</div>

<!-- MODAL -->
<!--<app-modal [innTemplate]="enviarModal" [titulo]="'EMPRESAS'" [idButton]="'abrirModal'" [idOpen]="'Modal'"
  [idClose]="'cerrarModal'"></app-modal>
<ng-template #enviarModal>
  <app-loading *ngIf="loadingUsuario"></app-loading>
    <div *ngIf="!listaVaciaUsuarios" class="row">
      <div [class]="'form-group col-md-12'">
        <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscarUser" id="quickFilter "
          (keyup)="onQuickFilterChangedUser()" #quickFilter />
      </div>
      <br>
    </div>
    <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVaciaUsuarios">
      No existen datos para la lista de Empresas.
    </div>
    <ag-grid-angular *ngIf="!listaVaciaUsuarios" 
      #agGrid class=" {{empModulo.agGrid.class}}" #agGrid
      [ngStyle]="empModulo.agGrid.style" 
      id="{{empModulo.agGrid.id}}" 
      [frameworkComponents]="frameworkComponentsEmpresas"
      [columnDefs]="columnDefsUser" 
      [rowSelection]="rowSelectionUser" 
      [rowData]="rowDataUser"
      (gridReady)="onGridReadyUser($event)" 
      [pagination]="true" 
      paginationPageSize="{{empModulo.agGrid.paginacion}}">
    </ag-grid-angular>
  
</ng-template> -->

